import React from 'react';
import SectionHeader from '../shared/SectionHeader';
import Button from '../shared/Button';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <SectionHeader
          title="Get In"
          highlight="Touch"
          subtitle="Have questions or ready to get started? We're here to help!"
        />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white rounded-2xl shadow-xl p-8 animate-slide-up">
            <h3 className="text-2xl font-bold mb-6 text-gray-800">Send Us a Message</h3>
            <form>
              <div className="mb-6">
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Your Name</label>
                <input 
                  type="text" 
                  id="name" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 input-field" 
                  placeholder="John Doe"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 input-field" 
                  placeholder="john@example.com"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Phone Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 input-field" 
                  placeholder="+27 12 345 6789"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Your Message</label>
                <textarea 
                  id="message" 
                  rows="5" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 input-field" 
                  placeholder="How can we help you?"
                ></textarea>
              </div>
              <Button 
                type="submit" 
                primary 
                className="px-8 py-4 text-lg w-full"
              >
                Send Message <i className="fas fa-paper-plane ml-2"></i>
              </Button>
            </form>
          </div>
          
          <div className="animate-slide-up" style={{ animationDelay: "0.2s" }}>
            <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
              <h3 className="text-2xl font-bold mb-6 text-gray-800">Contact Information</h3>
              <div className="space-y-6">
                 <ContactInfoItem
                  icon="fas fa-phone-alt"
                  title="Phone Number"
                  content="+27 609 881 456"
                />
                <ContactInfoItem
                  icon="fas fa-envelope"
                  title="Support Email Address"
                  content="support@storagesprint.co.za"
                />
                  <ContactInfoItem
                  icon="fas fa-envelope"
                  title="Contact Email Address"
                  content="info@storagesprint.co.za"
                />
              </div>
            </div>
            
            <div className="bg-yellow-500 rounded-2xl shadow-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Business Hours</h3>
              <div className="space-y-4">
                <BusinessHourItem day="Monday - Friday" time="8:00 AM - 10:00 PM" />
                <BusinessHourItem day="Saturday" time="9:00 AM - 4:00 PM" />
                <BusinessHourItem day="Sunday" time="Closed" last />
              </div>
              <div className="mt-8">
                <h4 className="font-bold mb-4">Emergency After Hours</h4>
                <p>For urgent storage needs outside business hours, please call our emergency line:</p>
                <div className="flex items-center mt-4">
                  <i className="fas fa-phone-alt mr-3"></i>
                  <span className="font-bold">+27 609 881 456</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ContactInfoItem = ({ icon, title, content }) => (
  <div className="flex items-start">
    <div className="bg-yellow-100 text-yellow-600 rounded-full p-3 mr-4">
      <i className={`${icon} text-xl`}></i>
    </div>
    <div>
      <h4 className="font-bold text-lg text-gray-800">{title}</h4>
      <p className="text-gray-600">{content}</p>
    </div>
  </div>
);

const BusinessHourItem = ({ day, time, last = false }) => (
  <div className={`flex justify-between ${last ? '' : 'border-b border-yellow-400 pb-2'}`}>
    <span>{day}</span>
    <span>{time}</span>
  </div>
);

export default ContactSection;